<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <CButton color="success" @click="newBlock" class="float-right">
              <CIcon name="cilPlus" />
              New Block
            </CButton>
            <h4>Blocks</h4>
          </CCardHeader>
          <CCardBody>
            <CAlert color="secondary" closeButton>
              <CIcon name="cil-lightbulb"/>
              <span class="pl-2">Blocks are a collection of items. Blocks can be part of a screen or viewed separately by the user. An item can be a podcast, episode or link</span>.
            </CAlert>
            <CAlert color="danger" v-if="missingBlocks">
              {{missingBlocks}}
            </CAlert>
            <CDataTable
              hover
              striped
              table-filter
              :items="items"
              :fields="fields"
              clickable-rows
              @row-clicked="rowClicked"
              :items-per-page="50"
              :active-page="activePage"
              :pagination="{ doubleArrows: false, align: 'center' }"
              @page-change="pageChange"
              :loading="isLoading"
            >
              <template #condition="data">
                <td>
                  <span v-if="data.item.condition_name">
                  <span v-if="data.item.condition_value">
                    {{ conditionLabel(data.item) }}
                  </span>
                  <s v-else>
                    {{ conditionLabel(data.item) }}
                  </s>
                  </span>
                </td>
              </template>
              <template #edit="">
                <td>
                  <CIcon name="cil-arrow-right" />
                </td>
              </template>
              <template slot="no-items-view" v-if="isLoading">
                <span>Loading items</span>
              </template> 

            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Blocks',
  data() {
    return {
      fields: [
        { key: 'id' },
        { key: 'name', _classes: 'font-weight-bold' },
        { key: 'block_type' },
        { key: 'on_screens' , 'label': 'Used on screens'},
        { key: 'autofill' , 'label': 'Autofill'},
        { key: 'condition' , 'label': 'Conditional'},
        { key: 'edit', label: ' ' },
      ],
      activePage: 1,
      settings: this.$settings,
      all_blocks: [],
    }
  },
  computed: {
    missingBlocks() {
      let missing = false
      let str = "The system expects a few specific blocks to exist. Please make sure to configure these. "
      this.items.map((e) => { 
          this.all_blocks.push(e.system_name)
      })
      this.settings["required_block_names"].forEach((block) => {
        if (!this.all_blocks.includes(block)) {
          missing = true
          str += "A block with a hook to `" + block + "` is required. "
        }
      })
      if (missing) {
        return str
      } else {
        return false
      }
    },
    isLoading() {
      return this.$store.state.blocks.isLoading
    },
    ...mapState({
      items: (state) => {
        const items = state.blocks.blocks.map(bl => { 
          bl.autofill = bl.meta.autofill
          return bl
        })
        return items
      },
    })
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      },
    },
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  methods: {
    rowClicked(item) {
      const blockId = `block-${item.id}`
      const warning = this.$store.getters.checkWarning(blockId)

      if (warning) {
        if (confirm('This will remove the changes you made to your previous block. Are you sure?')) {
          this.$router.push({ path: `blocks/${item.id}` })
        }
      } else {
        this.$router.push({ path: `blocks/${item.id}` })
      }
    },
    newBlock() {
      const warning = this.$store.getters.checkWarning('block-0')
      if (warning) {
        if (confirm('This will remove the changes you made to your previous block. Are you sure?')) {
          this.$router.push({ path: 'blocks/0' })
        }
      } else {
        this.$router.push({ path: 'blocks/0' })
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } })
    },
    getData() {
      this.$store.dispatch('getBlocks', { $api: this.$api })
    },
    conditionLabel(item) {
      const option = this.$settings.block_condition_name_options.find( ({ value }) => value === item.condition_name )
      return option["label"]
    }
  },
}
</script>
